import { IconSparkle, Skeleton } from '@vtex/shoreline'

import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import { useNtbMetricsGate } from '../../hooks/useNtbMetricsEnabled'
import { PageEmptyState } from './PageEmptyState'

/** Sem `allow_ntb_metrics` a tela sai do menu; por link direto, explica por que está vazia. */
export const NtbGate: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const { t } = useAPPTranslation()
  const { isEnabled, isPending } = useNtbMetricsGate()

  // sem isso a conta habilitada vê o aviso de "não habilitado" antes da resposta
  if (isPending) return <Skeleton style={{ height: '12rem' }} />

  if (!isEnabled) {
    return (
      <PageEmptyState
        icon={<IconSparkle width={28} height={28} />}
        title={t('rm:advertiserBrands.gate.title')}
        description={t('rm:advertiserBrands.gate.description')}
      />
    )
  }

  return <>{children}</>
}
